/** Initialer fra bruger-API — bruges til match mod opgave.tildelt (ikke navn eller login-brugernavn). */
export function hentAktuelBrugerInitialer(initialer?: string): string {
    return (initialer || "").trim();
}

/** Slår initialer op via fofbrugere-listen (samme data som tildelt i opret-opgave). */
export function loesInitialerFraFofBrugere(navn: string, brugere: ReadonlyArray<{ key: string; value: string }>): string {
    const trimmed = (navn || "").trim();
    if (!trimmed || brugere.length === 0) {
        return "";
    }

    const exact = brugere.find((bruger) => bruger.key === trimmed || bruger.value === trimmed);
    if (exact) {
        return exact.key.trim();
    }

    const prefixMatch = brugere.find((bruger) => bruger.value.startsWith(`${trimmed} (`));
    if (prefixMatch) {
        return prefixMatch.key.trim();
    }

    const lower = trimmed.toLowerCase();
    const navnMatch = brugere.find((bruger) => {
        const navnFraValue = bruger.value.replace(/\s*\([^)]+\)\s*$/, "").trim();
        return navnFraValue.toLowerCase() === lower;
    });
    return navnMatch?.key.trim() ?? "";
}
